<template>
  <a-drawer
    :title="title"
    :maskClosable="true"
    :width="drawerWidth"
    placement="right"
    :closable="true"
    @close="handleCancel"
    :visible="visible"
    style=" overflow: auto;padding-bottom: 53px;"
  >
    <template slot="title">
      <div style="width: 100%;">
        <span>{{ title }}</span>
        <span
          style="display:inline-block;width:calc(100% - 51px);padding-right:10px;text-align: right"
        >
          <a-button
            @click="toggleScreen"
            icon="appstore"
            style="height:20px;width:20px;border:0px"
          ></a-button>
        </span>
      </div>
    </template>

    <a-form :form="form">
      <div style="font-size:20px;font-weight:500;">基本信息</div>
      <a-form-item
        label="客户名称"
        :labelCol="labelCol"
        :wrapperCol="wrapperCol"
      >
        <a-input v-model="view.name" :readOnly="view.name" />
      </a-form-item>

      <a-form-item label="性别" :labelCol="labelCol" :wrapperCol="wrapperCol">
        <a-select v-model="view.gender" disabled="true">
          <a-select-option value="1">男</a-select-option>
          <a-select-option value="2">女</a-select-option>
        </a-select>
      </a-form-item>

      <a-form-item label="类型" :labelCol="labelCol" :wrapperCol="wrapperCol">
        <a-input v-model="view.type" :readOnly="view.type" />
      </a-form-item>

      <a-form-item
        label="手机号码"
        :labelCol="labelCol"
        :wrapperCol="wrapperCol"
      >
        <a-input v-model="view.phone" />
      </a-form-item>

      <a-form-item
        label="企业名称"
        :labelCol="labelCol"
        :wrapperCol="wrapperCol"
      >
        <a-input v-model="view.corp_name" :readOnly="view.type" />
      </a-form-item>
    </a-form>
    <div class="drawer-bootom-button" v-show="!disableSubmit">
      <a-popconfirm
        title="确定放弃编辑？"
        @confirm="handleCancel"
        okText="确定"
        cancelText="取消"
      >
        <a-button style="margin-right: .8rem">取消</a-button>
      </a-popconfirm>
      <a-button @click="handleSubmit()" type="primary" :loading="confirmLoading"
        >提交</a-button
      >
    </div>
  </a-drawer>
</template>

<script>
import Vue from 'vue';
// 引入搜索部门弹出框的组件
import JSelectPosition from '@/components/jeecgbiz/JSelectPosition';
import { ACCESS_TOKEN } from '@/store/mutation-types';
import { disabledAuthFilter } from '@/utils/authFilter';
import JImageUpload from '../../../components/jeecg/JImageUpload';
import { editByUser } from '@/api/api';

export default {
  name: 'BasicModal',
  components: {
    JImageUpload,
    JSelectPosition
  },
  data() {
    return {
      view: {
        name: '',
        gender: '',
        type: '',
        corp_name: '',
        phone: [],
        userid: '',
        external_userid: ''
      },
      departIdShow: false,
      departIds: [], //负责部门id
      title: '操作',
      visible: false,
      model: {},
      roleList: [],
      selectedRole: [],
      flag: false,
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
      },
      status: '',
      uploadLoading: false,
      confirmLoading: false,
      headers: {},
      form: this.$form.createForm(this),
      departDisabled: false, //是否是我的部门调用该页面
      roleDisabled: false, //是否是角色维护调用该页面
      modalWidth: 800,
      drawerWidth: 700,
      modaltoggleFlag: true,
      confirmDirty: false,
      selectedDepartKeys: [], //保存用户选择部门id
      checkedDepartKeys: [],
      checkedDepartNames: [], // 保存部门的名称 =>title
      checkedDepartNameString: '', // 保存部门的名称 =>title
      resultDepartOptions: [],
      userId: '', //保存用户id
      disableSubmit: false,
      userDepartModel: { userId: '', departIdList: [] }, // 保存SysUserDepart的用户部门中间表数据需要的对象
      dateFormat: 'YYYY-MM-DD'
    };
  },

  created() {
    const token = Vue.ls.get(ACCESS_TOKEN);
    this.headers = { 'X-Access-Token': token };
  },
  // inject: ['reload'],
  methods: {
    isDisabledAuth(code) {
      return disabledAuthFilter(code);
    },
    // inject: ['reload'],
    //窗口最大化切换
    toggleScreen() {
      if (this.modaltoggleFlag) {
        this.modalWidth = window.innerWidth;
      } else {
        this.modalWidth = 800;
      }
      this.modaltoggleFlag = !this.modaltoggleFlag;
    },

    add(data, records) {
      this.edit(data, records);
    },
    edit(data, records) {
      this.view.corp_name = data.corp_name;
      this.view.name = data.name;
      this.view.type = data.type;
      this.view.gender = data.gender;
      this.view.phone = data.phone;
      this.view.userid = records.userid;
      this.view.external_userid = records.external_contact.external_userid;
      this.resetScreenSize(); // 调用此方法,根据屏幕宽度自适应调整抽屉的宽度
      let that = this;
      that.visible = true;
    },
    handleSubmit() {
      var phones = [];
      phones.push(this.view.phone);
      let formData = {
        remark_mobiles: phones,
        userid: this.view.userid,
        external_userid: this.view.external_userid
      };
      editByUser(formData)
        .then(res => {
          if (res.success) {
            this.$message.success(res.message);
          } else {
            this.$message.success(res.message);
          }
        })
        .finally(() => {
          this.close();
          this.$emit('searchReset');
          // this.reload()
        });
    },
    handleCancel() {
      this.visible = false;
      this.close();
    },
    close() {
      this.$emit('close');
      this.visible = false;
      this.disableSubmit = false;
      this.selectedRole = [];
      this.userDepartModel = { userId: '', departIdList: [] };
      this.checkedDepartNames = [];
      this.checkedDepartNameString = '';
      this.checkedDepartKeys = [];
      this.selectedDepartKeys = [];
      this.resultDepartOptions = [];
      this.departIds = [];
      this.departIdShow = false;
      this.identity = '1';
      this.avatar_mediaid = [];
    },
    // 根据屏幕变化,设置抽屉尺寸
    resetScreenSize() {
      let screenWidth = document.body.clientWidth;
      if (screenWidth < 500) {
        this.drawerWidth = screenWidth;
      } else {
        this.drawerWidth = 700;
      }
    }
  }
};
</script>

<style scoped>
.avatar-uploader > .ant-upload {
  width: 104px;
  height: 104px;
}

.ant-upload-select-picture-card i {
  font-size: 49px;
  color: #999;
}

.ant-upload-select-picture-card .ant-upload-text {
  margin-top: 8px;
  color: #666;
}

.ant-table-tbody .ant-table-row td {
  padding-top: 10px;
  padding-bottom: 10px;
}

.drawer-bootom-button {
  position: absolute;
  bottom: -8px;
  width: 100%;
  border-top: 1px solid #e8e8e8;
  padding: 10px 16px;
  text-align: right;
  left: 0;
  background: #fff;
  border-radius: 0 0 2px 2px;
}
</style>
